module.exports = __webpack_public_path__ + "static/media/TwitterRounded.e7ecf856.svg";